import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type GetUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID'];
}>;


export type GetUserQuery = { __typename?: 'Query', usersPermissionsUser?: { __typename?: 'UsersPermissionsUser', documentId: string, username: string, firstName: string, lastName: string, color?: string | null, isPartTime?: boolean | null, redmineUserId?: number | null, rewardCoins?: number | null, punchShiftLimitMinutes?: number | null, company?: Types.Enum_Userspermissionsuser_Company | null, notificationTokens: Array<{ __typename?: 'NotificationToken', documentId: string, token: string } | null> } | null };

export type GetMeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'UsersPermissionsMe', id: string, documentId: string, email?: string | null, role?: { __typename?: 'UsersPermissionsMeRole', type?: string | null } | null } | null };

export type GetUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', usersPermissionsUsers: Array<{ __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, lastName: string, blocked?: boolean | null, isPartTime?: boolean | null, redmineUserId?: number | null, mustPunch?: boolean | null } | null> };

export type GetExpoNotificationTokensQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetExpoNotificationTokensQuery = { __typename?: 'Query', usersPermissionsUsers: Array<{ __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, notificationEnabled?: boolean | null, notificationTokens: Array<{ __typename?: 'NotificationToken', token: string } | null> } | null> };

export type GetUsersWithRewardsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUsersWithRewardsQuery = { __typename?: 'Query', usersPermissionsUsers: Array<{ __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, lastName: string, color?: string | null, rewardCoins?: number | null } | null> };

export type GetUserTimeShiftQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID'];
}>;


export type GetUserTimeShiftQuery = { __typename?: 'Query', usersPermissionsUser?: { __typename?: 'UsersPermissionsUser', documentId: string, punchShiftLimitMinutes?: number | null } | null };


export const GetUserDocument = `
    query getUser($userId: ID!) {
  usersPermissionsUser(documentId: $userId) {
    documentId
    username
    firstName
    lastName
    color
    isPartTime
    redmineUserId
    rewardCoins
    punchShiftLimitMinutes
    notificationTokens(pagination: {limit: -1}) {
      documentId
      token
    }
    company
  }
}
    `;
export const useGetUserQuery = <
      TData = GetUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserQueryVariables,
      options?: UseQueryOptions<GetUserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUserQuery, TError, TData>(
      ['getUser', variables],
      fetcher<GetUserQuery, GetUserQueryVariables>(client, GetUserDocument, variables, headers),
      options
    );

useGetUserQuery.getKey = (variables: GetUserQueryVariables) => ['getUser', variables];
;

export const GetMeDocument = `
    query GetMe {
  me {
    id
    documentId
    email
    role {
      type
    }
  }
}
    `;
export const useGetMeQuery = <
      TData = GetMeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMeQueryVariables,
      options?: UseQueryOptions<GetMeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetMeQuery, TError, TData>(
      variables === undefined ? ['GetMe'] : ['GetMe', variables],
      fetcher<GetMeQuery, GetMeQueryVariables>(client, GetMeDocument, variables, headers),
      options
    );

useGetMeQuery.getKey = (variables?: GetMeQueryVariables) => variables === undefined ? ['GetMe'] : ['GetMe', variables];
;

export const GetUsersDocument = `
    query getUsers {
  usersPermissionsUsers(
    filters: {blocked: {eq: false}}
    pagination: {limit: -1}
    sort: "firstName"
  ) {
    documentId
    firstName
    lastName
    blocked
    isPartTime
    redmineUserId
    mustPunch
  }
}
    `;
export const useGetUsersQuery = <
      TData = GetUsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetUsersQueryVariables,
      options?: UseQueryOptions<GetUsersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUsersQuery, TError, TData>(
      variables === undefined ? ['getUsers'] : ['getUsers', variables],
      fetcher<GetUsersQuery, GetUsersQueryVariables>(client, GetUsersDocument, variables, headers),
      options
    );

useGetUsersQuery.getKey = (variables?: GetUsersQueryVariables) => variables === undefined ? ['getUsers'] : ['getUsers', variables];
;

export const GetExpoNotificationTokensDocument = `
    query getExpoNotificationTokens {
  usersPermissionsUsers(
    filters: {and: {blocked: {eq: false}, notificationTokens: {token: {notNull: true}}, notificationEnabled: {eq: true}}}
    pagination: {limit: -1}
    sort: "firstName"
  ) {
    documentId
    firstName
    notificationEnabled
    notificationTokens(pagination: {limit: -1}) {
      token
    }
  }
}
    `;
export const useGetExpoNotificationTokensQuery = <
      TData = GetExpoNotificationTokensQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetExpoNotificationTokensQueryVariables,
      options?: UseQueryOptions<GetExpoNotificationTokensQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetExpoNotificationTokensQuery, TError, TData>(
      variables === undefined ? ['getExpoNotificationTokens'] : ['getExpoNotificationTokens', variables],
      fetcher<GetExpoNotificationTokensQuery, GetExpoNotificationTokensQueryVariables>(client, GetExpoNotificationTokensDocument, variables, headers),
      options
    );

useGetExpoNotificationTokensQuery.getKey = (variables?: GetExpoNotificationTokensQueryVariables) => variables === undefined ? ['getExpoNotificationTokens'] : ['getExpoNotificationTokens', variables];
;

export const GetUsersWithRewardsDocument = `
    query getUsersWithRewards {
  usersPermissionsUsers(
    filters: {blocked: {eq: false}, company: {eq: "Mediacross"}, mustPunch: {eq: true}}
    pagination: {limit: -1}
    sort: "firstName"
  ) {
    documentId
    firstName
    lastName
    color
    rewardCoins
  }
}
    `;
export const useGetUsersWithRewardsQuery = <
      TData = GetUsersWithRewardsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetUsersWithRewardsQueryVariables,
      options?: UseQueryOptions<GetUsersWithRewardsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUsersWithRewardsQuery, TError, TData>(
      variables === undefined ? ['getUsersWithRewards'] : ['getUsersWithRewards', variables],
      fetcher<GetUsersWithRewardsQuery, GetUsersWithRewardsQueryVariables>(client, GetUsersWithRewardsDocument, variables, headers),
      options
    );

useGetUsersWithRewardsQuery.getKey = (variables?: GetUsersWithRewardsQueryVariables) => variables === undefined ? ['getUsersWithRewards'] : ['getUsersWithRewards', variables];
;

export const GetUserTimeShiftDocument = `
    query getUserTimeShift($userId: ID!) {
  usersPermissionsUser(documentId: $userId) {
    documentId
    punchShiftLimitMinutes
  }
}
    `;
export const useGetUserTimeShiftQuery = <
      TData = GetUserTimeShiftQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserTimeShiftQueryVariables,
      options?: UseQueryOptions<GetUserTimeShiftQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUserTimeShiftQuery, TError, TData>(
      ['getUserTimeShift', variables],
      fetcher<GetUserTimeShiftQuery, GetUserTimeShiftQueryVariables>(client, GetUserTimeShiftDocument, variables, headers),
      options
    );

useGetUserTimeShiftQuery.getKey = (variables: GetUserTimeShiftQueryVariables) => ['getUserTimeShift', variables];
;
